export const routes = {
  cardsAndLists: {
    index: '/cards-and-lists',
    activeTab: '/cards-and-lists/:activeTab',
  },
  app: {
    info: '/app/information',
  },
  auth: {
    reset: '/auth/reset/:token',
  },
  handlers: {
    all: '/handlers',
    create: '/handlers/create',
    other: '/handlers/create/other',
    read: '/handlers/:handlerId',
    edit: '/handlers/:handlerId/edit',
  },
  search: '/search',
  events: {
    eventDetails: '/events/:eventId',
    latest: '/events',
    archive: '/archive',
    statistic: {
      all: '/statistic',
      read: '/statistic/:diagramType',
      create: '/statistic/:create',
    },
  },
  lists: {
    all: '/lists',
    read: '/lists/:listId',
  },
  externalId: {
    read: '/externalId/:externalId',
  },
  facePage: '/faces/:faceId',
  permissionTags: {
    list: '/permission-tags',
    view: '/permission-tags/:permissionTag',
  },
  departments: {
    list: '/departments',
  },
  users: {
    list: '/users',
    view: '/users/:userId',
  },
  roles: {
    list: '/roles',
    view: '/roles/:roleId',
  },
  sources: {
    list: '/sources',
    groupView: '/sources/groups/:groupId',
    streamView: '/sources/streams/:streamId',
    streamLive: '/sources/streams/:streamId/live',
  },
};
